// 结构化日志封装 / Structured logging wrapper for the SPA.
// 统一所有 info / warn / error 调用的前缀与字段格式。
// Keeps SPA-wide info/warn/error calls consistently prefixed and shaped.

/** Minimal structured logger. Keeps error / warn paths consistent across the SPA. */

type LogFields = Record<string, unknown>;

function emit(level: "log" | "warn" | "error", msg: string, fields?: LogFields): void {
  if (fields) {
    // eslint-disable-next-line no-console -- intentional: the SPA has no server-side log sink yet
    console[level](`[ripple] ${msg}`, fields);
  } else {
    // eslint-disable-next-line no-console
    console[level](`[ripple] ${msg}`);
  }
}

export const log = {
  info: (msg: string, fields?: LogFields) => emit("log", msg, fields),
  warn: (msg: string, fields?: LogFields) => emit("warn", msg, fields),
  error: (msg: string, fields?: LogFields) => emit("error", msg, fields),
};
